module.exports = __webpack_public_path__ + "static/media/funnel_description.773dc1d8.png";